<template>
  <div class="my-5">
        <div class="row align-items-center mb-5">
            <div class="col-md-auto mb-3 mb-lg-0">
                <h2 class="mb-0">Search</h2>
            </div>
            <div class="col-md-auto mb-3 mb-lg-0 form-group">
                <label for="query" class="visually-hidden">Search by Name/Organization</label>
                <input name="query" style="min-width:300px" v-model="query" type="text" class="form-control" placeholder="Search by Name/Organization">
            </div>
            <div class="col-md-auto mb-3 mb-lg-0 form-group">
                <label for="state" class="visually-hidden">Filter by State</label>
                <select name="state" v-model="state" class="form-select" placeholder="Filter by State">
                    <option value="">Filter by State</option>
                    <option v-for="s of states" :key="s" :value="s">{{s}}</option>
                </select>
            </div>
            <div class="col-md-auto">
                <button class="btn btn-primary" :disabled="!state&&!query" v-on:click="reset()">Clear</button>
            </div>
        </div>
        <ul class="list-unstyled" v-if="affiliates.length">
            <li class="mb-4" v-for="affiliate of filteredItems" :key="affiliate.ID">
                <h4 class="affiliate-title mb-2"><a :href="affiliate.link">{{affiliate.post_title}}</a></h4>
                <address>
                    <strong>Address</strong><br>
                    <span v-if="affiliate.address_1">{{affiliate.address_1}}<br></span>
                    <span v-if="affiliate.address_2">{{affiliate.address_2}}<br></span>
                    <span v-if="affiliate.address_3">{{affiliate.address_3}}<br></span>
                    <span v-if="affiliate.address_4">{{affiliate.address_4}}<br></span>
                    {{affiliate.city}}, {{affiliate.state}} {{affiliate.zip}}
                </address>
                <p v-if="affiliate.url">
                    <strong>Website</strong><br>
                    <a :href="affiliate.url" target="_blank">{{affiliate.url}}</a>
                </p>
            </li>
        </ul>
  </div>
</template>

<script>
export default {
    props: ['affiliates'],
    data() {
        return {
            items: [],
            query: '',
            state: '',
            queryProps: ['post_title', 'address_1', 'address_2', 'address_3', 'address_4', 'city', 'state', 'zip'],
        };
    },
    computed: {
        filteredItems() {
            if (!this.state && !this.query) {
                return this.items;
            }
            const _query = this.query.toLowerCase();
            return this.items.filter(a => {
                if (this.state && a.state !== this.state) {
                    return false;
                }
                if (this.query) {
                    return a.queryString.indexOf(_query) > -1;
                }
                return true;
            });
        },
        states() {
            return this.items.map(affiliate => affiliate.state).filter((a, i, self) => a != '' && self.indexOf(a) === i).sort();
        }
    },
    methods: {
        addPropsToItems(affiliate) {
            let queryItems = [];
            this.queryProps.forEach(prop => queryItems.push(affiliate[prop]));
            affiliate.people.forEach(person => queryItems.push(...[person.post_title, person.email, person.phone_1]));
            affiliate.queryString = queryItems.join(' ').toLowerCase();
            return affiliate;
        },
        reset() {
            this.query = '';
            this.state = '';
        }
    },
    mounted() {
        this.items = this.affiliates.map(this.addPropsToItems);
    }
}
</script>

<style>
    h4.affiliate-title a:not(:hover) { text-decoration: none; }
</style>